export const DONT_FETCH_USER_IN_THESE_PATHS = [
  '/session_expired',
  '/logout'
]
 
export const dontFetchInThisPath = (path) => {
  return DONT_FETCH_USER_IN_THESE_PATHS.includes(path);
}



// WEBPACK FOOTER //
// ./src/utils/url.js